import { fbt } from 'fbtee'
import { toast } from 'sonner'
import { formatErrorMessage, type ClassifiedError } from './errors'
import { openFeedback } from './feedbackBridge'

// Show an error toast with a "Report" action that opens the FeedbackDialog.
// Pass a ClassifiedError to attach error context to the report, or a plain
// string for user-input / non-system errors that still deserve a feedback
// channel.
export function toastError(title: string, errorOrMessage: ClassifiedError | string) {
  const description =
    typeof errorOrMessage === 'string' ? errorOrMessage : formatErrorMessage(errorOrMessage)
  const error = typeof errorOrMessage === 'string' ? undefined : errorOrMessage

  toast.error(title, {
    description,
    action: {
      label: fbt('Report', 'Action button on an error toast that opens the feedback dialog'),
      onClick: () => openFeedback(error ? { error } : undefined),
    },
    actionButtonStyle: {
      background: 'transparent',
      color: 'var(--error-text)',
      border: '1px solid currentColor',
      opacity: 0.85,
    },
  })
}
